/**
 * Papéis que acessam o painel completo (menu, pedidos, entregas, etc.).
 */
const DASHBOARD_ROLES = ['admin', 'mkt', 'owner'];

export function hasDashboardAccess(usuario){
	if(!usuario || !usuario.role || !Array.isArray(usuario.role)) return false;
	return DASHBOARD_ROLES.some((r) => usuario.role.includes(r));
}

/**
 * Apenas leitor de QR: tem `scanner` e nenhum papel de painel completo.
 */
export function isScannerOnly(usuario){
	if(!usuario || !usuario.role || !Array.isArray(usuario.role)) return false;
	if(!usuario.role.includes('scanner')) return false;
	return !hasDashboardAccess(usuario);
}
